import { Info } from "lucide-react";
import { Alert, AlertDescription } from "../../../../../components/ui/alert";

interface UnmappedFoldersWarningProps {
  fileCount: number;
}

// Says what happens to these files rather than that they are lost: they are
// uploaded with no sample of their own and scored against this procedure's
// samples, so some will land. Counted as "not in a mapped folder" rather than
// "in an unmapped folder" - a file at the archive root is in no folder at all,
// so the folder-based count missed it and the notice stayed hidden.
export function UnmappedFoldersWarning({
  fileCount,
}: UnmappedFoldersWarningProps) {
  return (
    <Alert className="bg-amber-50 border-amber-200">
      <Info className="h-4 w-4 text-amber-600" />
      <AlertDescription className="text-amber-800">
        {fileCount} file{fileCount !== 1 ? "s" : ""}{" "}
        {fileCount !== 1 ? "are" : "is"} not in a mapped folder, and will be
        matched on {fileCount !== 1 ? "their" : "its"} contents instead.
      </AlertDescription>
    </Alert>
  );
}
